import { createSelector } from 'reselect'

const getLtiForwardUrl = state => state.lti.ltiForwardUrl

const ltiDisplayViewSelector = createSelector(
	[ getLtiForwardUrl ],
	ltiForwardUrl => ({
		ltiForwardUrl,
	})
)

export default ltiDisplayViewSelector
